import { createClient } from '@supabase/supabase-js';

// Supabase configuration
// These are PUBLIC keys that are safe to expose in the frontend
export const SUPABASE_CONFIG = {
  url: process.env.REACT_APP_SUPABASE_URL || 'https://atxtjiatliqtabgcajxk.supabase.co',
  anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF0eHRqaWF0bGlxdGFiZ2NhanhrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg4Nzc5MTgsImV4cCI6MjA3NDQ1MzkxOH0.YCYaF59XPlW-NCaEa6pPUUxDQ6e-N1M2pRa54x5cS34'
};

// Create and export the Supabase client
export const supabase = createClient(SUPABASE_CONFIG.url, SUPABASE_CONFIG.anonKey);

// Note: SUPABASE_ANON_KEY is safe to expose - it's designed for client-side use
// Row Level Security (RLS) policies protect your data
